import React from 'react';
import WelcomeVideoTitle from './WelcomeVideoTitle';

interface WelcomeVideoHeaderProps {
  title: string;
}

const WelcomeVideoHeader: React.FC<WelcomeVideoHeaderProps> = ({ title }) => (
  <header>
    <WelcomeVideoTitle>{title}</WelcomeVideoTitle>
  </header>
);

export default WelcomeVideoHeader;
